// extracted by mini-css-extract-plugin
export var emailBlockLink = "_io-0";